var _rect, _rect2, _pattern, _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMediaIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 25,
    height: 25,
    fill: "url(#pattern0)"
  })), /*#__PURE__*/React.createElement("defs", null, _pattern || (_pattern = /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_336_575",
    transform: "scale(0.00030303)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "image0_336_575"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 537 464",
    width: 3000,
    height: 3000,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n                    .s0 {\n                        fill: #00953B\n                    }\n\n                    .s1 {\n                        fill: #19323C\n                    }\n\n                    .s2 {\n                        fill: #ffffff\n                    }\n                ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 0",
    className: "s0",
    d: "m64.2 156.3c-1.8 0.7-4.4 2.4-5.8 3.9-1.3 1.6-2.8 4.5-3.4 6.5-0.6 2.4-1 33.9-1 83.5 0 56.8 0.3 81.3 1.2 85 0.9 4.1 2.1 6.3 5.7 9.9 2.8 2.8 6.2 5.1 8.6 5.7 2.9 0.9 37.3 1.2 124.5 1.2 112.7 0 120.7-0.1 124-1.8 1.9-0.9 4.5-3.3 5.8-5.2l2.3-3.5c-0.1-174.2-0.1-176.1-2.1-179.3-1.1-1.8-3.9-4.1-6.3-5.2-4.1-1.9-6.7-2-127.2-1.9-91.5 0-123.9 0.4-126.3 1.2zm355.8 7c-0.5 1.2-3 7.5-5.5 13.9-3.4 9-4.2 12-3.3 12.6 0.7 0.5 9.2 3.7 18.8 7.1 9.6 3.5 17.8 6.6 18.2 7 0.4 0.3-8.9 28-20.8 61.6-11.9 33.6-26.8 75.7-33.2 93.8-6.5 18-12.2 32.7-12.7 32.7-0.6 0-13.9-4.7-29.8-10.5l-28.7-10.5c-74.4 0-83.5 0.3-83.6 1.2-0.1 0.8 30.3 12.4 79.5 30.2 43.8 15.9 80.2 29 80.9 29 0.9 0.1 16.2-41.5 45.3-122.9 24.1-67.7 43.8-123.1 43.7-123.2-0.2-0.1-15.2-5.6-33.3-12.2-18.2-6.7-33.3-12.1-33.8-12.1-0.4 0-1.2 1-1.7 2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 1",
    className: "s1",
    d: "m151.9 36.4c-0.3 1.1-8.7 24.5-18.6 51.9-9.9 27.4-18 50.3-18.1 50.8-0.1 0.5 6.6 0.8 15.9 0.7l16.1-0.3c18.1-49.8 23.6-64.5 24-64.9 0.5-0.3 44.3 15.2 97.5 34.5 53.3 19.4 97.6 35.4 98.5 35.8 1.4 0.5 0.2 4.6-9.3 30.6l-10.9 30c0 74.7 0.3 83.4 1.2 83.2 0.7-0.2 6.1-13.6 12-29.8 5.9-16.2 19-52.3 29.1-80.4 12.6-34.8 18.1-51.2 17.4-51.6-0.7-0.4-31.8-11.8-69.2-25.4-37.4-13.6-94.3-34.3-126.4-46-56-20.4-58.5-21.2-59.2-19.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 2",
    className: "s2",
    d: "m243.5 187.4c-3.9 3.9-4.2 4.8-4.4 9.7-0.1 3.8 0.5 6.4 1.9 8.6 1.1 1.9 3.9 4.2 6.3 5.3 3.2 1.5 6.4 2 13.7 2 7.9 0 10.3-0.4 14-2.2 3.3-1.7 5.1-3.5 6.8-6.8 1.7-3.3 2.1-5.4 1.7-8-0.4-1.9-1.5-4.8-2.5-6.5-1-1.7-3.2-3.8-4.9-4.8-2.5-1.4-5.5-1.7-15.7-1.7h-12.7zm-107.5 15.2c-4.1 0.9-11.3 3.4-16 5.6-6.1 3-10.1 5.8-14.5 10.2-3.3 3.4-7.4 8.8-9.2 12.1-1.7 3.3-4.1 9.6-5.3 14q-2.3 8-2.3 16.5c0 4.7 0.6 11 1.3 14 0.7 3.1 2.8 8.7 4.6 12.5 1.8 3.9 5.2 9.3 7.5 12 2.3 2.8 6.3 6.7 8.8 8.8 2.6 2.1 8 5.5 12.1 7.4 4.4 2.1 10.9 4.2 15.5 5.1 4.9 0.8 10.6 1.1 14.5 0.7 3.6-0.3 8.6-1 11-1.6 2.5-0.6 8.6-3 13.5-5.4 6.9-3.2 10.4-5.7 14.6-10.1 3.1-3.2 6.8-7.9 8.2-10.4 1.4-2.4 3.8-8.1 5.4-12.5 2.3-6.9 2.7-9.6 2.8-19.5 0-10.1-0.4-12.5-2.8-19.5-1.6-4.4-4.9-11.1-7.5-14.9-2.6-3.8-7.4-9.2-10.7-11.9-3.3-2.7-8.4-6.2-11.5-7.7-3-1.5-7.9-3.5-11-4.4-3-0.9-9.1-1.8-13.5-2.1-5-0.2-10.8 0.2-15.5 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 3",
    className: "s1",
    d: "m143.5 225.2c-3.5 0.5-8.5 2.2-11.9 4.1-3.3 1.8-7.5 5-9.3 7.2-1.9 2.2-4.5 6-5.8 8.5-1.3 2.5-2.8 7.2-3.4 10.5-0.7 4.1-0.8 7.9-0.1 12 0.5 3.3 2.2 8.4 3.7 11.4 1.6 3 5.2 7.5 8.3 10.3 3.1 2.8 7.9 5.9 11 7.1 4 1.5 7.8 2.1 14 2.1 7.4 0 9.3-0.4 15-3.1 4.5-2.1 8.1-4.9 11.8-8.9 3.2-3.6 6.2-8.1 7.4-11.4 1.5-3.8 2.1-7.9 2.1-13.5 0-6.8-0.4-9-2.9-14.5-1.7-3.6-4.6-8.3-6.6-10.5-1.9-2.2-6.2-5.4-9.4-7.2-3.3-1.7-7.7-3.4-9.9-3.8-2.2-0.3-4.9-0.7-6-0.9-1.1-0.2-4.7 0.1-8 0.6z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaIcon);
export default __webpack_public_path__ + "static/media/media-icon.ea75d3f292b0b2a0dd7ceecf96aed8cd.svg";
export { ForwardRef as ReactComponent };